import { BaseField } from "./base";

export class DynamicSelectField extends BaseField {
	constructor(field, form) {
		super(field, form);
		this.sourceField = null;
		this.rules = [];
		this.currentRule = null;
		this.init();
	}

	init() {
		// Get source field name and rules from data attributes
		this.sourceFieldName = this.field.dataset.sourceField;

		try {
			this.rules = JSON.parse(this.field.dataset.rules || "[]");
		} catch (e) {
			console.error("Failed to parse dynamic select rules:", e);
			this.rules = [];
		}

		if (!this.sourceFieldName) {
			console.error("Source field name not specified");
			return;
		}

		// Update options when any form input changes
		this.form.addEventListener("input", () => this.updateOptions());
		// Initial update
		this.updateOptions();
	}

	updateOptions() {
		const formData = new FormData(this.form);
		const sourceValue = formData.get(this.sourceFieldName) || "";
		let matchedRule = null;

		// Find the first matching rule
		for (const rule of this.rules) {
			if (this.matchesRule(sourceValue, rule)) {
				matchedRule = rule;
				break;
			}
		}

		// Only update if the rule has changed
		if (matchedRule !== this.currentRule) {
			this.currentRule = matchedRule;

			// Clear existing options
			this.field.innerHTML = "";

			// Add options based on matched rule
			if (matchedRule) {
				matchedRule.options.forEach((option) => {
					const optionElement = document.createElement("option");
					optionElement.value = option.value;
					optionElement.textContent = option.label;
					this.field.appendChild(optionElement);
				});
			}

			// Trigger change event to notify any listeners
			this.field.dispatchEvent(new Event("change"));
		}
	}

	matchesRule(value, rule) {
		if (rule.useRegex) {
			try {
				const regex = new RegExp(rule.value);
				return regex.test(value);
			} catch (e) {
				console.error("Invalid regex pattern:", e);
				return false;
			}
		}
		return value === rule.value;
	}
}
